module.exports = __webpack_public_path__ + "img/csr-12.d91f350b.jpg";